import { useResolvedAccessLevel } from '../../components/PermissionsContainer';

/**
 * Component id for the Change All ENTRY POINT — the amber action-bar button on
 * every PRO TanTable (Search Results, LC Dashboards, Dispatch Dashboard).
 *
 * Split out of `order-lc-fields` deliberately. That component is the per-FIELD
 * write gate for the LC-only order fields, and it was doing double duty as the
 * gate on the button, which tied "may open a bulk surface at all" to "may edit
 * LC fields". Dispatch and Scheduling need the first without the second: their
 * use of Change All is creating the same trouble ticket across a list of pros,
 * which is its own endpoint pair and its own audience.
 */
export const CHANGE_ALL_COMPONENT_ID = 'change-all';

/**
 * Whether the current user may open Change All on a table of PROs.
 *
 * Ships **defaultDisabled**, like the two gates it was split from: until an
 * admin grants a group edit access on `change-all`, the button is hidden for
 * everyone. Migration 478 seeds the grant for the groups that could use it
 * before the split (Developers, LCManager, DispatchManager,
 * LogisticCoordinators) plus the new audience (Dispatch, DispatchAssistant,
 * Scheduler) — WITHOUT it the button disappears for all of them, so the
 * migration is not optional on any schema this ships to.
 *
 * Opening the drawer is all this grants. What may be FANNED OUT from it is
 * still decided per arm, by the arms' own permissions:
 *   order + leg fields  `order-lc-fields` (orders) / `template-edit-fields`
 *                       (templates) — enforced in the UI by the ChangeAll
 *                       provider's `canFanFields` and server-side by
 *                       `_require_field_edit_access`.
 *   trouble tickets     the TT change-all endpoint grant.
 *   notes, documents    their own endpoint grants.
 * So a Dispatcher with this component and nothing else gets the ticket, note
 * and document fan-outs, and no field checkboxes at all.
 */
export const useCanUseChangeAll = (): boolean =>
  useResolvedAccessLevel(CHANGE_ALL_COMPONENT_ID, false, true) >= 2;
